import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, UseFiltersResult } from "@/modules/common/filters";
import {
  AdminAneelTariffSortField,
  TARIFF_MODALITY_OPTIONS,
  TARIFF_TYPE_OPTIONS,
  TariffModalities,
  TariffTypes,
} from "@/modules/common/types/AneelTariffs.enum";
import useEnergyDistributorOptions from "@/modules/common/hooks/lists/useEnergyDistributorOptions";

import { ANEEL_TARIFF_FILTER_FIELDS } from "../../../constants/AneelTariffFilterFields";
import { ListAneelTariffsDto } from "@/service/dto/admin-aneel-tariffs";

const ANEEL_TARIFF_SORT_OPTIONS = [
  { field: AdminAneelTariffSortField.NAME, label: "Nome" },
  { field: AdminAneelTariffSortField.CREATED_AT, label: "Data de criação" },
  { field: AdminAneelTariffSortField.EFFECTIVE_DATE, label: "Início da vigência" },
  { field: AdminAneelTariffSortField.EXPIRATION_DATE, label: "Fim da vigência" },
];

interface TariffsFilterBarProps {
  filters: UseFiltersResult<ListAneelTariffsDto>;
  sort: SortDropdownValue<AdminAneelTariffSortField> | null;
  onSortChange: (sort: SortDropdownValue<AdminAneelTariffSortField> | null) => void;
}

const TariffsFilterBar = ({ filters, sort, onSortChange }: TariffsFilterBarProps) => {
  const {
    options: distributorOptions,
    isLoading: isLoadingDistributorOptions,
    hasMore: hasMoreDistributorOptions,
    onLoadMore: fetchMoreDistributorOptions,
  } = useEnergyDistributorOptions();

  return (
    <EntityFilterBar
      filters={filters}
      sort={sort}
      onSortChange={onSortChange}
      sortOptions={ANEEL_TARIFF_SORT_OPTIONS}
      filterFields={ANEEL_TARIFF_FILTER_FIELDS}
      modalTitle="Filtrar Tarifas"
      searchPlaceholder="Pesquisar tarifa..."
    >
      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Distribuidora"
          options={distributorOptions}
          isLoading={isLoadingDistributorOptions}
          hasMore={hasMoreDistributorOptions}
          onLoadMore={fetchMoreDistributorOptions}
          value={filters.values.energyDistributorId}
          onChange={(next) => filters.setValue("energyDistributorId", next)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Modalidade"
          options={TARIFF_MODALITY_OPTIONS}
          value={filters.values.modality !== undefined ? String(filters.values.modality) : undefined}
          onChange={(next) => filters.setValue("modality", next !== undefined ? (Number(next) as TariffModalities) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Tipo"
          options={TARIFF_TYPE_OPTIONS}
          value={filters.values.type !== undefined ? String(filters.values.type) : undefined}
          onChange={(next) => filters.setValue("type", next !== undefined ? (Number(next) as TariffTypes) : undefined)}
        />
      </FilterBar.Item>
    </EntityFilterBar>
  );
};

export default TariffsFilterBar;
